import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import AgreementCheckbox from 'components/shared/form/AgreementCheckbox';

class MyForm extends Component {
 
    render = () => {
        const { handleSubmit, submitting, sagaAction } = this.props; 
       
        return (
            <form className="form" onSubmit={handleSubmit(sagaAction)}>
                {this.props.children}

                {/* AGREEMENT CHECKBOX */}
                {this.props.requireAgree && (
                    <AgreementCheckbox backUrl={this.props.agreeBackUrl} onChange={(e) => this.toggleSubmitButton(e)}/>
                )}

                {/* SUBMIT BUTTON */}
                <button
                    className={'button-submit ' + this.props.buttonClasses}
                    type="submit"
                    ref="submitButton"
                    disabled={submitting}
                >
                    {this.props.submitLabel}
                </button>
            </form>
        );
    };

    // Disable/Enable submit depending if agreed or not
    toggleSubmitButton(event) {
        if (event.target.value) {
            this.refs.submitButton.disabled = false;
        } else {
            this.refs.submitButton.disabled = true;
        }
    }
}

function mapStateToProps(state, props) {
    return {
        form: props.name,
        initialValues: props.initialValues || {},
        keepDirtyOnReinitialize: props.keepDirty || false,
    };
}

MyForm = reduxForm({
    destroyOnUnmount: false,
    enableReinitialize: true,
    multipartForm : true
})(MyForm);
MyForm = connect(mapStateToProps, null, null, { withRef: true })(MyForm);

export default MyForm;



// WEBPACK FOOTER //
// ./src/components/shared/form/MyForm.js